<template>
  <highliter
    v-model="section.name"
    :section="section"
    :dublicate="section"
    class="highlight-element w-full"
    :class="{'element-hidden': !visability('code')}"
    @delete="$emit('delete')"
    @dublicate="$emit('dublicate')"
    @favorite="$emit('favorite', $el)"
    @flow="handleFlow"
    @move-to="to => $emit('move-to', to)"
    @add-subject="$emit('add-subject')"
    @click.stop.native="sectionSettings('code')"
  >
    <div :data-sid="section.sid">
      <div :class="`--${section.sid}--wrapper`">
        <div class="flex flex-col items-center justify-center bg-gray-300 h5 p-4 mb-0 text-center">
          Estage Internal Embed Block
          <span
            v-if="section.options.content.code.title"
            class="text-base text-gray-600 mt-2"
          >
            {{ section.options.content.code.title }}
          </span>
        </div>
      </div>
    </div>
  </highliter>
</template>

<script>
import Highliter from '@builder/components/builder/utils/Highliter'
import SectionMixin from '@builder/components/mixins/SectionMixin'

export default {
  name: 'ElInternalEmbedBlock',
  components: {Highliter},
  mixins: [SectionMixin]
}
</script>